import moment from "moment-timezone";

export const getCurrentYear = () => {
  return moment(Date.now()).tz("Europe/Berlin").year();
};
